// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.error-boundary-content {
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.error-icon {
  font-size: 64px;
  margin-bottom: 20px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.error-boundary-content h1 {
  color: #333;
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
}

.error-message {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.error-details {
  text-align: left;
  margin: 20px 0;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 15px;
}

.error-details summary {
  cursor: pointer;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 10px;
}

.error-stack {
  background: #2d2d2d;
  color: #f8f8f2;
  padding: 15px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.error-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-retry,
.btn-home {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-retry {
  background: #667eea;
  color: white;
}

.btn-retry:hover {
  background: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.btn-home {
  background: #f5f5f5;
  color: #333;
}

.btn-home:hover {
  background: #e0e0e0;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-boundary-content {
    padding: 30px 20px;
  }

  .error-boundary-content h1 {
    font-size: 24px;
  }

  .error-icon {
    font-size: 48px;
  }

  .error-actions {
    flex-direction: column;
  }

  .btn-retry,
  .btn-home {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/ErrorBoundary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".error-boundary-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.error-boundary-content {\n  background: white;\n  border-radius: 12px;\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.error-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.error-boundary-content h1 {\n  color: #333;\n  font-size: 28px;\n  margin-bottom: 16px;\n  font-weight: 600;\n}\n\n.error-message {\n  color: #666;\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 30px;\n}\n\n.error-details {\n  text-align: left;\n  margin: 20px 0;\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.error-details summary {\n  cursor: pointer;\n  font-weight: 600;\n  color: #667eea;\n  margin-bottom: 10px;\n}\n\n.error-stack {\n  background: #2d2d2d;\n  color: #f8f8f2;\n  padding: 15px;\n  border-radius: 6px;\n  overflow-x: auto;\n  font-size: 12px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.error-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-retry,\n.btn-home {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-retry {\n  background: #667eea;\n  color: white;\n}\n\n.btn-retry:hover {\n  background: #5568d3;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.btn-home {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.btn-home:hover {\n  background: #e0e0e0;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .error-boundary-content {\n    padding: 30px 20px;\n  }\n\n  .error-boundary-content h1 {\n    font-size: 24px;\n  }\n\n  .error-icon {\n    font-size: 48px;\n  }\n\n  .error-actions {\n    flex-direction: column;\n  }\n\n  .btn-retry,\n  .btn-home {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
